import { SettingsRow } from '@/shared/ui/settings/settings-row';

export function SecurityDeleteAccountRow() {
    return (
        <SettingsRow
            label="Delete account"
            caption="Email hello@nessoapp.com to permanently delete your account"
        />
    );
}
